import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import moment from 'moment';

import Input from 'app/src/elements/inputs';

import { PRE_BID_SCHEDULES } from './queries';

const PreBidSchedulePicker = ({ name, control, errors, saleOn, setValue }) => {
  const { data } = useQuery(PRE_BID_SCHEDULES);

  useEffect(() => {
    if (data && saleOn) {
      const weekday = moment(saleOn).day();

      const schedule = data.preBidSchedules.find(({ saleWeekday }) => (
        saleWeekday === weekday
      ));

      setValue('preBidScheduleId', schedule?.id || data.preBidSchedules[0].id);
    }
  }, [saleOn, data]);

  if (!data) { return null; }

  const options = data.preBidSchedules.map(({ name, id }) => (
    { value: id, label: name }
  ));

  return (
    <Input.Picker
      label="Pre Bid Pricing Schedule"
      name={name || 'preBidScheduleId'}
      options={options}
      control={control}
      errors={errors}
      rules={{ required: true }}
    />
  );
};

export default PreBidSchedulePicker;
